import { useQuery } from "@tanstack/react-query";
import { useAuth } from "./useAuth";
import { useDependencies } from "./useDependencies";
import { useDocumentationAreaIdAndActorId } from "./useDocumentationAreaIdAndActorId";

export const useGetConsents = () => {
  const { documentationAreaController } = useDependencies();
  const { token } = useAuth();
  const { documentationAreaId } = useDocumentationAreaIdAndActorId();

  const queryFn = async () => {
    if (!documentationAreaId) {
      throw new Error("Calling /GET Consents without DocumentationAreaId");
    }
    const response = await documentationAreaController.getConsents(token, documentationAreaId);
    return response;
  };

  const {
    isPending: isLoading,
    data: acceptanceCheckboxes,
    error,
  } = useQuery({
    queryKey: ["Consents", documentationAreaId],
    queryFn,
    retry: false,
  });

  return { isGetConsentsLoading: isLoading, acceptanceCheckboxes, error };
};
